import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { OnClear } from '~/services/clearModule';

@InjectModule({ stateFactory: true }, module)
@OnClear<SnackbarModule>(async value => value.clear())
export default class SnackbarModule extends InjectVuexModule {
    isOpen = false;
    message = '';
    color = 'black';

    @Mutation
    updateVisibility(isOpen: boolean) {
        this.isOpen = isOpen;
    }

    @Mutation
    updateMessage(newMessage: string) {
        this.message = newMessage;
    }

    @Mutation
    updateColor(newColor: string) {
        this.color = newColor;
    }

    @Action
    showMessage(payload: { message: string; timeout?: number; color?: string }) {
        this.updateMessage(payload.message);
        this.updateColor(payload.color || 'black');
        this.updateVisibility(true);

        setTimeout(() => {
            this.clear();
        }, payload.timeout || 3000);
    }

    @Mutation
    clear() {
        this.isOpen = false;
        this.message = '';
        this.color = 'black';
    }
}
